import Paragraph from "../sub-component/paragraph/paragraph.sub-component";

const TeamCard = ({ props, index }) => {
  return (
    <div className="h-[278px] w-[218px] md:h-[340px] md:w-[273px] mx-2 md:mx-4 rounded-xl md:rounded-3xl flex">
      <div
        className="h-full w-full relative bg-cover"
        data-aos="zoom-out-up"
        data-aos-duration={1000}
        data-aos-delay={200 + 1000 * (index + 1)}
      >
        <div className="to-bg-black-10 absolute inset-0 h-full w-full bg-gradient-to-t from-black/80 via-black/50 rounded-2xl">
          <div className="flex flex-col gap-1 w-full h-full justify-end px-2 py-3 md:py-4 md:px-3 lg:px-4 lg:py-5 text-gray-200">
            <Paragraph>{props.name}</Paragraph>
            <Paragraph>{props.title}</Paragraph>
            <div className="flex gap-1">
              {props.skills.length > 0 &&
                props.skills.map((data, index) => (
                  <div
                    className="border border-gray-500 rounded-2xl py-[2px] px-2 lg:py-1"
                    key={index}
                  >
                    <Paragraph className="border-2">{data}</Paragraph>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="h-full w-full bg-center bg-cover rounded-2xl">
          <img
            src={props.imageUrl}
            alt="avatar"
            className="w-full h-full inset-0 bg-center object-cover rounded-2xl"
          />
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
